import { TranslationKeyMap } from './pillar-two.i18n';

export enum StatusViewType {
    WORKING,
    UPDATED,
    NEW,
    REVIEWING,
    BEING_DISPUTED,
    HIGHLIGHTED,
}

export const StatusViewTypeLabelMap = {
    [StatusViewType.WORKING]:
        TranslationKeyMap._9582_WORKING_ON_THIS_COMMITMENT,
    [StatusViewType.UPDATED]: TranslationKeyMap._9594_UPDATED,
    [StatusViewType.NEW]: TranslationKeyMap._9595_NEW,
    [StatusViewType.REVIEWING]:
        TranslationKeyMap._9819_REVIEWING_THIS_COMMITMENT,
    [StatusViewType.BEING_DISPUTED]:
        TranslationKeyMap._9819_REVIEWING_THIS_COMMITMENT,
    [StatusViewType.HIGHLIGHTED]: null,
};

export const StatusViewTypeColorMap = {
    [StatusViewType.WORKING]: '#d17300',
    [StatusViewType.UPDATED]: '#137e0f',
    [StatusViewType.NEW]: '#0e3b8a',
    [StatusViewType.REVIEWING]: '#d17300',
    [StatusViewType.BEING_DISPUTED]: '#d17300',
    [StatusViewType.HIGHLIGHTED]: '#1e60d4',
};
